"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeSearchValues = void 0;
function encodeSearchValues(values) {
    if (!values)
        return values;
    const encoded = {};
    for (const [key, value] of Object.entries(values)) {
        if (value === null || value === undefined || value === '') {
            encoded[key] = value;
            continue;
        }
        encoded[key] = encodeURIComponent(String(value));
    }
    return encoded;
}
exports.encodeSearchValues = encodeSearchValues;
